// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reports_title__DEXtc {
  margin-top: 10px;
  font-size: 24px;
  letter-spacing: 0.03em; }
  .reports_title__DEXtc span {
    font-size: 18px;
    color: #9e9e9e; }

.reports_container__w11yo {
  width: 100%;
  height: calc(100vh - 190px);
  margin-top: 20px;
  display: flex;
  overflow: hidden; }

.reports_choose__mCzZ8 {
  width: 50%;
  padding-right: 10px;
  border-right: 1px solid #e0e0e0; }

.reports_reports__xWHOB {
  width: 100%;
  height: calc(100vh - 190px);
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 20px; }
  .reports_reports_item__Fycgd {
    display: flex;
    flex-direction: column;
    width: 98%;
    height: 130px;
    background-color: white;
    transition: all 0.5s;
    cursor: pointer;
    border-radius: 4px; }
    .reports_reports_item__Fycgd:hover {
      background: rgba(254, 97, 0, 0.1); }
    .reports_reports_item__Fycgd svg {
      height: 16px;
      width: 16px;
      margin-right: 5px; }
    .reports_reports_item__Fycgd .reports_inside__iOVui {
      width: 100%;
      height: 100%;
      display: flex; }
      .reports_reports_item__Fycgd .reports_inside_content__tOgnL {
        padding: 13px;
        height: 100%;
        width: 90%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        gap: 10px; }
    .reports_reports_item_title__ykJG\\+ {
      gap: 5px;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px; }
      .reports_reports_item_title__ykJG\\+ span {
        color: #9e9e9e; }

.reports_red__JnJxT {
  height: 100%;
  width: 10px;
  background-color: #e00606;
  border-radius: 4px 0 0 4px; }

.reports_green__r1kqa {
  height: 100%;
  width: 10px;
  background-color: #87bc45;
  border-radius: 4px 0 0 4px; }

.reports_active__ryIqx {
  margin: 3px;
  box-shadow: rgba(254, 97, 0, 0.4) 0px 0px 0px 2px, rgba(254, 97, 0, 0.65) 0px 4px 6px -1px, rgba(254, 97, 0, 0.08) 0px 1px 0px inset; }
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/components/reports/reports.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB,EAAA;EAHxB;IAKI,eAAe;IACf,cAAc,EAAA;;AAGlB;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,gBAAgB,EAAA;;AAElB;EACE,UAAU;EACV,mBAAmB;EACnB,+BAA+B,EAAA;;AAGjC;EACE,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;EACT;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;IACf,kBAAkB,EAAA;IARnB;MAUG,iCAAiC,EAAA;IAVpC;MAaG,YAAY;MACZ,WAAW;MACX,iBAAiB,EAAA;IAfpB;MAkBG,WAAW;MACX,YAAY;MACZ,aAAa,EAAA;MApBhB;QAsBK,aAAa;QACb,YAAY;QACZ,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,6BAA6B;QAC7B,SAAS,EAAA;IAGb;MACE,QAAQ;MACR,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;MAJlB;QAMG,cAAc,EAAA;;AAKtB;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,0BAA0B,EAAA;;AAE5B;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,0BAA0B,EAAA;;AAE5B;EACE,WAAW;EACX,oIAC0C,EAAA","sourcesContent":[".title {\n  margin-top: 10px;\n  font-size: 24px;\n  letter-spacing: 0.03em;\n  span {\n    font-size: 18px;\n    color: #9e9e9e;\n  }\n}\n.container {\n  width: 100%;\n  height: calc(100vh - 190px);\n  margin-top: 20px;\n  display: flex;\n  overflow: hidden;\n}\n.choose {\n  width: 50%;\n  padding-right: 10px;\n  border-right: 1px solid #e0e0e0;\n}\n\n.reports {\n  width: 100%;\n  height: calc(100vh - 190px);\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  &_item {\n    display: flex;\n    flex-direction: column;\n    width: 98%;\n    height: 130px;\n    background-color: white;\n    transition: all 0.5s;\n    cursor: pointer;\n    border-radius: 4px;\n    &:hover {\n      background: rgba(254, 97, 0, 0.1);\n    }\n    svg {\n      height: 16px;\n      width: 16px;\n      margin-right: 5px;\n    }\n    .inside {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      &_content {\n        padding: 13px;\n        height: 100%;\n        width: 90%;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n        gap: 10px;\n      }\n    }\n    &_title {\n      gap: 5px;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 24px;\n      span {\n        color: #9e9e9e;\n      }\n    }\n  }\n}\n.red {\n  height: 100%;\n  width: 10px;\n  background-color: #e00606;\n  border-radius: 4px 0 0 4px;\n}\n.green {\n  height: 100%;\n  width: 10px;\n  background-color: #87bc45;\n  border-radius: 4px 0 0 4px;\n}\n.active {\n  margin: 3px;\n  box-shadow: rgba(254, 97, 0, 0.4) 0px 0px 0px 2px, rgba(254, 97, 0, 0.65) 0px 4px 6px -1px,\n    rgba(254, 97, 0, 0.08) 0px 1px 0px inset;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `reports_title__DEXtc`,
	"container": `reports_container__w11yo`,
	"choose": `reports_choose__mCzZ8`,
	"reports": `reports_reports__xWHOB`,
	"reports_item": `reports_reports_item__Fycgd`,
	"inside": `reports_inside__iOVui`,
	"inside_content": `reports_inside_content__tOgnL`,
	"reports_item_title": `reports_reports_item_title__ykJG+`,
	"red": `reports_red__JnJxT`,
	"green": `reports_green__r1kqa`,
	"active": `reports_active__ryIqx`
};
export default ___CSS_LOADER_EXPORT___;
